import React, { Component,Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { notify } from '../../../util/notifications';
import {exportRatePlan} from '../../../actions/adminAction/importExportRatePlanAction';

class ExportRatePlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
        file: null,
        inputFileRef: React.createRef(),
        selectedDate: null,
        accountType: ''
    };
  }

 onExportRatePlan = (selectedDate, accountType) => {
    const { dispatch, refNotify } = this.props;
    if (!this.state.accountType || this.state.accountType === '') {
        notify.createNotification('error', 'Please select account type', refNotify);
        return;
        }
    if (!this.state.selectedDate|| !this.state.selectedDate === '') {
        notify.createNotification('error', 'Please select a valid date', refNotify);
        return;
    }
    dispatch(exportRatePlan(selectedDate, accountType));
    notify.createNotification('success', 'Account rate plans has been exported successfully', refNotify);
  };

  render() {
    const { accountTypes, refNotify } = this.props;
    return (
      <Fragment>
         <div className='row'>
           <div className='col-md-12'>
             <form>
                <div className="form-row">
                     <div className="form-group col-md-6">
                         <label htmlFor="accountTyep">Account Type</label>
                           <select
                                className="form-control form-control-sm"
                                name="accountType"
                                value={this.state.accountType}
                                onChange={(e) => {
                                    this.setState({ accountType: e.target.value });
                                }}
                                >
                                <option value="">Account Type</option>
                                {accountTypes.map((state, key) => {
                                    return (
                                    <option key={key} value={state.optionVal}>
                                        {state.optionTxt}
                                    </option>
                                    );
                                })}
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                            <label htmlFor="date">As Of</label>
                              <div>
                                <DatePicker
                                    id="date"
                                    name="date"
                                    className="form-control"
                                    selected={
                                        this.state.selectedDate
                                        ? new Date(this.state.selectedDate) // convert string back to Date
                                        : null
                                    }
                                    onChange={(date) => {
                                        // convert to YYYY-MM-DD format and store as string
                                        const formattedDate = date?.toISOString().split('T')[0]; // '2025-07-28'
                                        this.setState({ selectedDate: formattedDate });
                                    }}
                                    dateFormat="MM/dd/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={10}
                                    disabledKeyboardNavigation
                                    placeholderText="MM/DD/YYYY"
                                    />
                             </div>                   
                       </div>
                     
                    </div>
                     <div class="form-group col-md-2 align-self-end">
                       <button type="button" className="btn btn-primary" onClick={()=>{                        
                        this.onExportRatePlan( this.state.selectedDate, this.state.accountType);
                        this.setState({ selectedDate: null, accountType: '' }); // Reset state after export
                       }}>Export</button>
                      </div>   
                 </form>
             </div>
          </div>
      </Fragment>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    accountTypes: state.accountTypes.accountTypes,
    refNotify: state.refNotify,
    authInfo: state.authInfo,
    AccountList: state.accountList.accountInfoList
  };
};
export default withRouter(connect(mapStateToProps)(ExportRatePlan));